<template>
  <div
    v-if="hasVideo"
    class="-mx-12 pt-12 px-12 flex flex-col justify-between border-t border-purple-ap-t03"
  >
    <div>
      <h2 class="font-semibold text-purple-ap-100">
        Video
      </h2>
    </div>
    <div class="mt-5">
      <div class="video-container">
        <iframe :src="embedVideo" frameborder="0" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Video",
  data() {
    return {
      hasVideo: false,
    };
  },
  props: ["video"],
  computed: {
    embedVideo() {
      let video_id = this.video.split("v=")[1];
      if (video_id) {
        let ampersandPosition = video_id.indexOf("&");
        if (ampersandPosition != -1) {
          video_id = video_id.substring(0, ampersandPosition);
        }
        return `https://www.youtube.com/embed/${video_id}`;
      } else {
        return this.video;
      }
    },
  },
  created() {
    var term = this.embedVideo;
    var re = new RegExp("^(http(s)?://)?((w){3}.)?youtu(be|.be)?(.com)?/.+");
    if (re.test(term)) {
      this.hasVideo = true;
    } else {
      this.hasVideo = false;
    }
  },
};
</script>

<style scoped>
.video-container {
  float: none;
  clear: both;
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 25px;
  height: 0;
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
